// TennisTrack Hub — Dashboard Principale | 029 Project
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import Navbar from '../../components/Navbar';
import './Dashboard.css';

const Dashboard = () => {
  const { utente } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ atleti: 0, prossimeLezioni: [], template: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const caricaDashboard = async () => {
      try {
        const [resAtleti, resProssime, resTemplate] = await Promise.all([
          api.get('/atleti'),
          api.get('/lezioni/prossime'),
          api.get('/template/miei')
        ]);
        setStats({
          atleti: resAtleti.data.atleti.length,
          prossimeLezioni: resProssime.data.lezioni,
          template: resTemplate.data.template.length
        });
      } catch (err) {
        console.error('Errore caricamento dashboard:', err.message);
      } finally {
        setLoading(false);
      }
    };
    caricaDashboard();
  }, []);

  const formatData = (dataOra) => {
    const d = new Date(dataOra);
    return d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
  };

  const formatOra = (dataOra) => {
    return new Date(dataOra).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="page-layout">
      <Navbar />
      <main className="dashboard-main">

        {/* Saluto */}
        <div className="dashboard-header">
          <div>
            <h1>Ciao, {utente?.nome}! 🎾</h1>
            <p>Ecco il riepilogo del tuo Hub</p>
          </div>
        </div>

        {/* Statistiche */}
        <div className="dashboard-grid">
          <div className="card stat-card clickable" onClick={() => navigate('/atleti')}>
            <div className="stat-icon">🎾</div>
            <div className="stat-info">
              <span className="stat-number">{loading ? '—' : stats.atleti}</span>
              <span className="stat-label">Atleti attivi</span>
            </div>
          </div>

          <div className="card stat-card">
            <div className="stat-icon">📅</div>
            <div className="stat-info">
              <span className="stat-number">{loading ? '—' : stats.prossimeLezioni.length}</span>
              <span className="stat-label">Lezioni in programma</span>
            </div>
          </div>

          <div className="card stat-card clickable" onClick={() => navigate('/template')}>
            <div className="stat-icon">📋</div>
            <div className="stat-info">
              <span className="stat-number">{loading ? '—' : stats.template}</span>
              <span className="stat-label">I miei template</span>
            </div>
          </div>

          <div className="card stat-card">
            <div className="stat-icon">💪</div>
            <div className="stat-info">
              <span className="stat-number">∞</span>
              <span className="stat-label">Allenamenti</span>
            </div>
          </div>
        </div>

        {/* Prossime lezioni */}
        <div className="dashboard-section">
          <div className="section-header">
            <h2>📅 Prossime lezioni</h2>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/atleti')}>
              Vedi atleti
            </button>
          </div>

          {loading ? (
            <div className="card loading-card">Caricamento...</div>
          ) : stats.prossimeLezioni.length === 0 ? (
            <div className="card empty-card">
              <p>Nessuna lezione in programma. <span className="link" onClick={() => navigate('/atleti')}>Vai agli atleti →</span></p>
            </div>
          ) : (
            <div className="lezioni-preview">
              {stats.prossimeLezioni.map(l => (
                <div key={l.id} className="card lezione-preview-item" onClick={() => navigate(`/atleti/${l.atleta_id}`)}>
                  <div className="lp-data">
                    <strong>{formatData(l.data_ora)}</strong>
                    <span>{formatOra(l.data_ora)}</span>
                  </div>
                  <div className="lp-atleta">
                    <span>{l.atleta_nome} {l.atleta_cognome}</span>
                    <span className="lp-tipo">{l.tipo === 'tennis' ? '🎾' : '💪'} {l.tipo} · {l.durata_min} min</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Azioni rapide */}
        <div className="dashboard-section">
          <h2>⚡ Azioni rapide</h2>
          <div className="quick-actions">
            <button className="card quick-action-btn" onClick={() => navigate('/atleti/nuovo')}>
              <span className="qa-icon">➕</span>
              <span>Nuovo atleta</span>
            </button>
            <button className="card quick-action-btn" onClick={() => navigate('/atleti')}>
              <span className="qa-icon">🎾</span>
              <span>Gestisci atleti</span>
            </button>
            <button className="card quick-action-btn" onClick={() => navigate('/atleti')}>
              <span className="qa-icon">💪</span>
              <span>Nuovo allenamento</span>
            </button>
            <button className="card quick-action-btn" onClick={() => navigate('/template')}>
              <span className="qa-icon">📋</span>
              <span>Libreria template</span>
            </button>
          </div>
        </div>

      </main>

      <footer className="dashboard-footer">
        <img src="/img/madeby029.png" alt="029 Project" className="footer-logo" />
      </footer>
    </div>
  );
};

export default Dashboard;
